module.exports = __webpack_public_path__ + "img/课程全面.a2603331.png";